(function() {
    'use strict';

    angular.module('app.perfilesAsiento', []);
})();
